import api from './api';

export const agentService = {
    // --- User Management ---
    getUsers: async (params) => {
        try {
            const response = await api.get('/agent/users', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    createUser: async (userData) => {
        try {
            const response = await api.post('/agent/users', userData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateUser: async (userId, userData) => {
        try {
            const response = await api.put(`/agent/users/${userId}`, userData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getUser: async (userId) => {
        try {
            const response = await api.get(`/agent/users/${userId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteUser: async (userId) => {
        try {
            const response = await api.delete(`/agent/users/${userId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getUserWallets: async (userId) => {
        try {
            const response = await api.get(`/agent/users/${userId}/wallets`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // --- Balance & Finance ---
    adjustBalance: async (userId, data) => {
        try {
            // Corrected endpoint
            const response = await api.post(`/agent/users/${userId}/adjust-balance`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // --- Wallet Management (Agent's Own Wallets) ---
    getMyWallets: async () => {
        try {
            const response = await api.get('/agent/my-wallets');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    addMyBankCard: async (data) => {
        try {
            const response = await api.post('/agent/my-wallets/bank-card', data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateMyBankCard: async (id, data) => {
        try {
            const response = await api.put(`/agent/my-wallets/bank-card/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    addMyCryptoWallet: async (data) => {
        try {
            const response = await api.post('/agent/my-wallets/crypto-wallet', data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateMyCryptoWallet: async (id, data) => {
        try {
            const response = await api.put(`/agent/my-wallets/crypto-wallet/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteMyBankCard: async (id) => {
        try {
            const response = await api.delete(`/agent/my-wallets/bank-card/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateMyBankCardStatus: async (id, status) => {
        try {
            const response = await api.put(`/agent/my-wallets/bank-card/${id}/status`, { status });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteMyCryptoWallet: async (id) => {
        try {
            const response = await api.delete(`/agent/my-wallets/crypto-wallet/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateMyCryptoWalletStatus: async (id, status) => {
        try {
            const response = await api.put(`/agent/my-wallets/crypto-wallet/${id}/status`, { status });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // --- Withdrawals ---
    getWithdrawals: async (params) => {
        try {
            const response = await api.get('/agent/withdrawals', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    reviewWithdrawal: async (id, data) => {
        try {
            const response = await api.post(`/agent/withdrawals/${id}/review`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    auditWithdrawal: async (id, data) => {
        return agentService.reviewWithdrawal(id, data);
    },

    // --- Trades ---
    getTrades: async (params) => {
        try {
            const response = await api.get('/agent/trades', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // --- Stats ---
    getDashboardStats: async () => {
        try {
            const response = await api.get('/agent/dashboard-stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getTransactions: async (params) => {
        try {
            const response = await api.get('/agent/transactions', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // --- Win/Loss Control ---
    updateWinLossControl: async (userId, data) => {
        try {
            const response = await api.put(`/agent/users/${userId}/win-loss-control`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // --- Profile ---
    updateProfile: async (data) => {
        try {
            const response = await api.put('/agent/profile', data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    changePassword: async (data) => {
        try {
            const response = await api.put('/agent/change-password', data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // --- Announcements ---
    getAnnouncements: async () => {
        try {
            const response = await api.get('/agent/announcements');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    createAnnouncement: async (data) => {
        try {
            const response = await api.post('/admin/announcements', data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteAnnouncement: async (id) => {
        try {
            const response = await api.delete(`/admin/announcements/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};
